import useI18n from 'i18n/useI18n';
import { useEffect, useMemo } from 'react';
import useWindowDimensions from 'hooks/useWindowDimensions';
import { getTranslatedCategories } from 'pages/MenuItems/utils/transformers';

const MAX_TEXT_LENGHT = 27;
const BASE_TEXT_LENGHT = 18;
const SCREEN_BREAKPOINT = 1024;

const useTranslatedFiltersSelect = ( baseOptions = null, selectedOptions = null, updateSelectedOptions = ([])=>{} ) => {
  const { width } = useWindowDimensions();
  const { translate, selectedLang } = useI18n();

  useEffect(()=>{
    const newOptions = getTranslatedCategories(
      baseOptions.filter( option => selectedOptions.some( opt => opt.value === option.value)),
      translate,
      selectedLang
    );
    if( newOptions.length > 0 ) updateSelectedOptions(newOptions);
  }, [selectedLang]);

  const options = useMemo(()=>{
    if( !baseOptions ) return null;
    return getTranslatedCategories(baseOptions, translate, selectedLang);
  }, [selectedLang, baseOptions]);

  const placeholder = useMemo(()=>{
    if( !selectedOptions ) return '';

    const text = selectedOptions.map((option) => option.label).join(' | ')
    const textLenght = width > SCREEN_BREAKPOINT ? MAX_TEXT_LENGHT : BASE_TEXT_LENGHT;    

    if( text.length < textLenght ) return text;

    const textElements = text.split('');
    textElements.splice(textLenght-3, text.length-(textLenght-3)); // Ellipsis dots space
    return textElements.join('') + '...'; 
  },[selectedLang, selectedOptions]);

  return ([
    options,
    placeholder,
  ]);
}
export default useTranslatedFiltersSelect;